// @ts-strict-ignore
import { ArticleAttributeVO, ArticleInfoVO, CarrierBlockVO, ComplexProjectVO, CustomsTariffNumberVO, FinalizationPreselectionVO, MetaElementInfoVO, ProjectArticleNumberInfoVO, ProjectFinalizationInfoVO, ProjectHeadVO, ProjectHistoryEntryVO, ProjectHistoryVO, ProjectOptionDefLocalizationVO, ProjectOptionLocalizationVO, ProjectSaveInfoVO, ProjectVO, RequestFinalizeProjectResultVO } from '@project/model/vo/project.vo';
import { ProjectGroupVO } from '@project/model/vo/project-group.vo';
import { CustomArticleInfoVO, CustomArticleLibraryVO, CustomArticleVO, CustomImageDataVO } from '@project/components/article/model/vo/custom-article.vo';
import { AddressVO, CountryInfoVO, MdmGroupVO, OrganizationVO, UserPermissionVO, UserProfileVO, UserRoleVO, UserVO } from '@user/model/vo/user.vo';
import { SystemConfigurationVO } from '../system-configuration/system-configuration.vo';
import { BorderDataVO, LabelTextureDataVO, LabelTextureDescriptionVO, LabelTextureRequestVO, TextureCacheEntry } from '@3d-scene/processor/texture.vo';
import { SearchResultVO } from '@project/components/article/model/vo/search-result.vo';
import { ConverterHelper } from './converter.helper';
import { DrillingHoleDataVO, DrillingholePresetVO } from '@project/actions/drilling-hole/drilling-hole.vo';
import { ArticleAccessoryEntryVO, ArticleAccessoryInfoVO } from '@article/model/vo/article-accessory-info-vo';
import { ArticleSearchResultVO } from '@article/model/vo/article-search-result.vo';
import { JsonConvert, JsonCustomConvert } from './convert-core';
import {
  ArticleDescriptorVOConverter,
  ArticleVOConverter,
  ArticleVOsConverter,
  ArticleWithTechnicalPropertiesConverter,
  DateConverter,
  ElementReferenceVOsConverter,
  LocalizedPropertyValueVOsConverter,
  MetaElementUsageVOsConverter,
  MetaElementVOsConverter,
  PropertyVOConverter,
  QuickFixActionVOsConverter,
  RepresentationDataVOConverter,
  RepresentationVOsConverter,
  StringArticleVODictionaryConverter,
  StringProjectVODictionaryConverter,
  StringValueInLocalesVOConverter,
  TextSizeCheckRequestVOConverter,
  TextSizeCheckVOsConverter,
  TextValueVOConverter,
} from './model.converter';
import { ArticleCollectionVO, ArticleCompositionVO, ArticleMetadataVO, ArticleTechnicalInfoVO, ArticleTypeClassVO, ArticleTypeVO, ArticleUsageVO, ArticleVO } from '@article/model/vo/article.vo';
import { ConnectionSearchResultVO } from '@project/components/article/model/vo/connection-search-result.vo';
import { CompressionSimpleTextValueVO, ConnectionAreaUsageVO, ConnectionAreaVO, ConnectionFreedomVO, ConnectionVO, DefinedMetaElementPropertyVO, ImageValueVO, MetaElementUsageIdentityVO, MetaElementUsageVO, MetaElementVO, MontagePointAreaVO, RGBColorValueVO, SimpleTextValueVO, TableTextItemVO, TableTextRowVO, TableTextValueVO, TextureAreaUsageVO, TextureAreaVO, TextValueVO } from '../vo/meta-element.vo';
import { FloatRangeVO, IntRangeVO, LocalizedPropertyValueVO, LocalizedStringValueVO, PropertyInLocalesVO, PropertyValueVO, PropertyVO, ReportGenerationPropertyVO, StringValueInLocalesVO, UserSettingPropertyVO } from '@project/components/article/model/vo/property.vo';
import { OBJRepresentationDataVO, RepresentationDataVO, RepresentationVO } from '../vo/representation.vo';
import { SuitableConnectionAreasVO } from '@project/components/article/model/vo/suitable-connection-areas.vo';
import { SuitableConnectionsSetVO } from '@project/components/article/model/vo/suitable-connections-set.vo';
import { SuitableConnectionsVO } from '@project/components/article/model/vo/suitable-connections.vo';
import { SeriesCategoryVO } from '@article/service/model/series.category.vo';
import { OldArticleNumberMappingVO } from '@article/model/vo/old-article-number-mapping.vo';
import { OrderConnectionInformationVO } from '@project/components/article/model/vo/order-connection-information.vo';
import { ArticleNumberMappingListVO } from '@article/model/vo/article-number-mapping.vo';
import { TextSizeCheckRequestResponseVO } from '@3d-scene/manager/text-size-check.vo';
import { GenerationResponseVO } from '@project/manager/generation-response.vo';
import { FriendInfoVO } from '@project/components/permissions/friend-info.vo';
import { FriendListEntryVO } from '@project/components/permissions/friend-list-entry.vo';
import { SharedUserRightVO } from '@user/model/vo/shared-user-right.vo';
import { SharedObjectInfoVO, SharedProjectGroupInfoVO, SharedProjectInfoVO } from '@project/components/permissions/shared-info.vo';
import { ArticleToColorValueInLocalesVO, ColorValueInLocalesVO } from '@article/model/vo/article-to-color-value-in-locales.vo';
import { ReportVO } from '@project/model/vo/report.vo';
import { FavoriteArticlesWrapperVO, FavoriteArticleVO } from '@user/components/favorites/models/favorite-article.vo';
import { CadFormatVO } from '@article/components/data-center-export/cad-format.vo';
import { ApplyTextToTextureAreaUsageQuickFixActionVO, ArticleCalculationResultVO, ArticleDescriptorVO, DeferredArticlePropertiesResultVO, DeleteArticleQuickFixActionVO, ElementReferenceVO, InsertArticleQuickFixActionVO, IOConsumptionResultVO, ListArticleDescriptorVO, QuickFixActionVO, QuickFixVO, RuleResultVO, SingleArticleDescriptorVO, UsageArticleDescriptorVO, ValidationContextVO, ValidationResultVO } from '@project/model/vo/validation-context.vo';
import { ArticleLocationVO } from '@article/model/vo/article-location.vo';
import { UserOptionDefsVO } from '@user/model/vo/user-option-defs.vo';
import { SaveProjectCaeDTO } from '@project/model/vo/save-project-cae.dto';
import { SaveProjectCaeResponseDTO } from '@project/model/vo/save-project-cae-response.dto';
import { ProductionPlantVO } from '@project/model/vo/production-plant.vo';
import { ProductionCountryVO } from '@article/model/vo/production-country.vo';
import { NotificationVO } from '../vo/notification.vo';
import { ElbridgeHookVO } from '@project/components/project/elbridge/vo/elbridge-hook.vo';
import { ItemListObjectVO } from '@article/service/model/item-list-object.vo';
import { CountryCodeVO } from '../vo/country-code.vo';
import { BuildingBlockHeadVO, BuildingBlockSaveResponseVO, BuildingBlockVO, IEKBuildingBlockVO } from '@project/model/vo/building-block.vo';
import { PriceCalculationResultVO } from '@project/model/vo/price-calculation-data.vo';
import { ProjectLinkAccessVO } from '@project/model/vo/project-link-access-vo';
import { ArticleEndPlateInfoVO } from '@article/model/vo/article-end-plate-info-vo';
import { ArticleColorVariantsInfoVO, ArticleColorVariantVO } from '@article/model/vo/article-color-variants-info.vo';
import { ArticleNosToHeadMappingVO } from '@article/model/vo/articlesnos-to-head-mapping';
import { AccessorySearchResultVO, ArticleInfoConnectionSetVO } from '@project/components/article/model/vo/accessory-search-result.vo';
import { Injectable } from '@angular/core';
import { UserRightDefVO } from '@article/model/vo/user-right-def.vo';
import { UserRightsInfoVO } from '@article/model/vo/user-rights-info.vo';
import { WxArcVO, WxArticleShapeVO, WxArticleVO, WxCarrierVO, WxConnectionVO, WxDrawingElementVO, WxEnvelopePointVO, WxEnvelopeVO, WxProjectArticleVO, WxProjectConnectionPinVO, WxProjectConnectionVO, WxRectangleVO, WxTextVO } from '@article/model/vo/wx-article.vo';
import { UpdateCompositeArticleResult } from '@article/model/vo/update-composite-article-result.vo';
import { ArticleTechDataValueVO } from '@article/model/vo/article-tech-data.vo';
import { LabelDuplicateVO } from '@project/model/vo/label-duplicate.vo';
import { ArticleNumberLong } from '@project/model/article-number-long';

@Injectable({ providedIn: 'root' })
export class ModelConversionService {

  protected customConverters: JsonCustomConvert<any>[];
  protected jsonObjects: any[];

  constructor() {
    // Initialization of the custom converters.
    this.customConverters = [
      new DateConverter(), new PropertyVOConverter(), new RepresentationDataVOConverter(), new MetaElementVOsConverter(),
      new MetaElementUsageVOsConverter(), new TextValueVOConverter(), new StringValueInLocalesVOConverter(),
      new RepresentationVOsConverter(), new StringArticleVODictionaryConverter(), new StringProjectVODictionaryConverter(),
      new ArticleVOConverter(), new ArticleVOsConverter(), new TextSizeCheckRequestVOConverter(),
      new TextSizeCheckVOsConverter(), new QuickFixActionVOsConverter(), new ArticleDescriptorVOConverter(), new ElementReferenceVOsConverter(),
      new LocalizedPropertyValueVOsConverter(), new ArticleWithTechnicalPropertiesConverter(),
    ];
    this.customConverters = undefined;

    this.jsonObjects = [
      new ArticleEndPlateInfoVO(), new ArticleAccessoryInfoVO(), new ArticleAccessoryEntryVO(), new ArticleSearchResultVO(), new ArticleUsageVO(),
      new ArticleCompositionVO(), new ArticleVO(), new ArticleCollectionVO(), new ArticleMetadataVO(), new ArticleTechnicalInfoVO(),
      new ArticleToColorValueInLocalesVO(), new ColorValueInLocalesVO(),
      new ConnectionSearchResultVO(), new AccessorySearchResultVO() , new ArticleInfoConnectionSetVO() ,  new CustomArticleInfoVO(),
      new CustomArticleLibraryVO(), new CustomImageDataVO(), new CustomArticleVO(), new DrillingholePresetVO(), new MetaElementVO(),
      new ConnectionFreedomVO(), new ConnectionAreaVO(), new MontagePointAreaVO(), new RGBColorValueVO(), new TextValueVO(),
      new SimpleTextValueVO, new CompressionSimpleTextValueVO(), new ImageValueVO(), new TextureAreaVO(), new MetaElementUsageIdentityVO(),
      new MetaElementUsageVO(), new ConnectionVO(), new ConnectionAreaUsageVO(), new TableTextItemVO(), new TableTextRowVO(),
      new TableTextValueVO(), new TextureAreaUsageVO(), new DefinedMetaElementPropertyVO(), new ProjectGroupVO(), new MetaElementInfoVO(),
      new ArticleAttributeVO(), new ArticleInfoVO(), new ProjectOptionLocalizationVO(),
      new ProjectOptionDefLocalizationVO(), new ArticleNumberLong(),
      new CarrierBlockVO(), new ProjectHistoryEntryVO(), new ProjectHistoryVO, new ProjectHeadVO(), new ProjectVO(), new ComplexProjectVO(), new ProjectLinkAccessVO(),
      new ProjectSaveInfoVO(), new IntRangeVO(), new FloatRangeVO(), new PropertyValueVO(),
      new LocalizedPropertyValueVO(), new PropertyVO(), new ReportGenerationPropertyVO(), new UserSettingPropertyVO(),
      new LocalizedStringValueVO(), new StringValueInLocalesVO(), new PropertyInLocalesVO(), new RepresentationDataVO(),
      new RepresentationVO(), new OBJRepresentationDataVO(), new SearchResultVO(),
      new SuitableConnectionAreasVO(), new SuitableConnectionsSetVO(), new SuitableConnectionsVO(), new SystemConfigurationVO(),
      new BorderDataVO(), new LabelDuplicateVO(), new LabelTextureDataVO(), new LabelTextureDescriptionVO(), new UserRoleVO(), new UserPermissionVO(),
      new OrganizationVO(), new CountryInfoVO(), new AddressVO(), new UserVO(), new MdmGroupVO(), new UserProfileVO(), new LabelTextureRequestVO(),
      new TextureCacheEntry(),
      new SeriesCategoryVO(), new OldArticleNumberMappingVO(), new OrderConnectionInformationVO(),
      new GenerationResponseVO(),
      new ProjectFinalizationInfoVO(),
      new FriendInfoVO(), new FriendListEntryVO(), new SharedUserRightVO(),
      new SharedObjectInfoVO(), new SharedProjectInfoVO(), new SharedProjectGroupInfoVO(),
      new ReportVO(), new FavoriteArticleVO(), new FavoriteArticlesWrapperVO(), new ArticleLocationVO(),
      new CadFormatVO(), new ValidationContextVO(), new ArticleDescriptorVO(), new ListArticleDescriptorVO(), new SingleArticleDescriptorVO(),
      new UsageArticleDescriptorVO(), new QuickFixActionVO(), new InsertArticleQuickFixActionVO(),
      new DeleteArticleQuickFixActionVO(), new ApplyTextToTextureAreaUsageQuickFixActionVO(), new QuickFixVO(), new ElementReferenceVO(),
      new RuleResultVO(), new ArticleCalculationResultVO(), new DeferredArticlePropertiesResultVO(), new ValidationResultVO(),
      new CadFormatVO(), new UserOptionDefsVO(),
      new RequestFinalizeProjectResultVO(),
      new ItemListObjectVO(), new UserOptionDefsVO(), new SaveProjectCaeResponseDTO(), new SaveProjectCaeDTO(),
      new ProductionCountryVO(), new DrillingHoleDataVO(), new ProductionPlantVO(), new NotificationVO, new ElbridgeHookVO, new CountryCodeVO,
      new IEKBuildingBlockVO(), new BuildingBlockSaveResponseVO(), new BuildingBlockVO(), new BuildingBlockHeadVO(), new CustomsTariffNumberVO(), new FinalizationPreselectionVO(),
      new UserRightDefVO(), new UserRightsInfoVO(),
      new ArticleColorVariantsInfoVO(), new ArticleColorVariantVO(), new ArticleNosToHeadMappingVO(), new ProjectArticleNumberInfoVO(),
      new WxArticleVO(), new WxArticleShapeVO(), new WxDrawingElementVO(),
      new WxEnvelopeVO(), new WxEnvelopePointVO(), new WxRectangleVO(), new WxArcVO(), new WxTextVO(), new WxConnectionVO(),
      new WxCarrierVO(), new WxProjectArticleVO(), new WxProjectConnectionVO(), new WxProjectConnectionPinVO(), new UpdateCompositeArticleResult(),
      new WxCarrierVO(), new WxProjectArticleVO(), new WxProjectConnectionVO(), new WxProjectConnectionPinVO(), new ArticleTechDataValueVO(),
    ];
    this.jsonObjects = undefined;
  }

  public convertArticleVOs(data: any[]): ArticleVO[] {
    return ConverterHelper.convertToArticleVOs(data);
  }

  public convertArticleVO(data: any): ArticleVO {
    return ConverterHelper.convertToArticleVO(data);
  }

  public convertMetaElementVOs(data: any): MetaElementVO[] {
    return ConverterHelper.convertToMetaElementVOs(data);
  }

  public convertArticleTypeVOs(data: any): ArticleTypeVO[] {
    return JsonConvert.deserialize(data, '[ArticleTypeVO]' );
  }

  public convertOldArticleNumberMappingVOs(data: any[]): OldArticleNumberMappingVO[] {
    return JsonConvert.deserialize(data, '[OldArticleNumberMappingVO]' );
  }

  public convertOrderConnectionInformationVOs(data: any[]): OrderConnectionInformationVO[] {
    return JsonConvert.deserialize(data, '[OrderConnectionInformationVO]' );
  }

  public convertProductionPlantsVOs(data: any[]): ProductionPlantVO[] {
    return JsonConvert.deserialize(data, '[ProductionPlantVO]' );
  }

  public convertCountryCodeVOs(data: any[]): CountryCodeVO[] {
    return JsonConvert.deserialize(data, '[CountryCodeVO]' );
  }

  public convertArticleTypeClassVOs(data: any[]): ArticleTypeClassVO[] {
    return JsonConvert.deserialize(data, '[ArticleTypeClassVO]' );
  }

  public convertSeriesGategoryVOs(data: any[]): SeriesCategoryVO[] {
    return JsonConvert.deserialize(data, '[SeriesCategoryVO]' );
  }

  public convertProjectHeadVO(data: any): ProjectHeadVO {
    return JsonConvert.deserialize(data, 'ProjectHeadVO');
  }

  public convertListProjectHeadVO(data: any): ProjectHeadVO[] {
    return JsonConvert.deserialize(data, '[ProjectHeadVO]');
  }

  public convertProjectVO(data: any): ProjectVO {
    return JsonConvert.deserialize(data, 'ProjectVO');
  }

  public convertProjectVOs(data: any[]): ProjectVO[] {
    return JsonConvert.deserialize(data, '[ProjectVO]');
  }

  public convertProjectHistoryVO(data: any): ProjectHistoryVO {
    return JsonConvert.deserialize(data, 'ProjectHistoryVO');
  }

  public convertPriceCalculationResultVO(data: any): PriceCalculationResultVO {
    return JsonConvert.deserialize(data, 'PriceCalculationResultVO');
  }

  public convertSaveProjectCaeResponseDTO(data: any[]): SaveProjectCaeResponseDTO {
    return JsonConvert.deserialize(data, 'SaveProjectCaeResponseDTO');
  }

  public convertProjectGroupVO(data: any): ProjectGroupVO {
    return JsonConvert.deserialize(data, 'ProjectGroupVO');
  }

  public convertProjectGroupsVO(data: any): ProjectGroupVO[] {
    return JsonConvert.deserialize(data, '[ProjectGroupVO]');
  }

  public convertComplexProjectVO(data: any): ComplexProjectVO {
    return JsonConvert.deserialize(data, 'ComplexProjectVO');
  }

  public convertCustomArticleLibraryVOs(data: any): CustomArticleLibraryVO[] {
    return JsonConvert.deserialize(data, '[CustomArticleLibraryVO]');
  }

  public convertCustomImageDataVO(data: any): CustomImageDataVO {
    return JsonConvert.deserialize(data, 'CustomImageDataVO');
  }

  public convertUserProfileVO(data: any): UserProfileVO {
    return JsonConvert.deserialize(data, 'UserProfileVO');
  }

  public convertUserVO(data: any): UserVO {
    return JsonConvert.deserialize(data, 'UserVO');
  }

  public convertUserVOs(data: any): UserVO[] {
    return JsonConvert.deserialize(data, '[UserVO]');
  }

  public convertMdmGroupVO(data: any): MdmGroupVO {
    return JsonConvert.deserialize(data, 'MdmGroupVO');
  }
  public convertMdmGroupVOs(data: any): MdmGroupVO[] {
    return JsonConvert.deserialize(data, '[MdmGroupVO]');
  }

  public convertSystemConfigurationVO(data: any): SystemConfigurationVO {
    return JsonConvert.deserialize(data, 'SystemConfigurationVO');
  }

  public convertLabelTextureDataVOs(data: any): LabelTextureDataVO[] {
    return JsonConvert.deserialize(data, '[LabelTextureDataVO]');
  }

  public convertTextureCacheEntry(data: any): TextureCacheEntry {
    return JsonConvert.deserialize(data, 'TextureCacheEntry');
  }

  public convertArticleTechnicalInfoMap(data: any): Map<number, ArticleTechnicalInfoVO> {
    return ConverterHelper.convertToArticleTechnicalInfoMap(data);
  }

  public convertDrillingholePresetVO(data: any): DrillingholePresetVO {
    return JsonConvert.deserialize(data, 'DrillingholePresetVO');
  }

  public convertArticleUsageVO(data: any): ArticleUsageVO {
    return JsonConvert.deserialize(data, 'ArticleUsageVO');
  }

  public convertArticleAccessoryInfoVO(data: any): ArticleAccessoryInfoVO {
    return JsonConvert.deserialize(data, 'ArticleAccessoryInfoVO');
  }

  public convertArticleAccessoryInfoVOs(data: any): ArticleAccessoryInfoVO[] {
    return JsonConvert.deserialize(data, '[ArticleAccessoryInfoVO]');
  }

  public convertArticleAccessoryEntryVOs(data: any): ArticleAccessoryEntryVO[] {
    return JsonConvert.deserialize(data, '[ArticleAccessoryEntryVO]');
  }

  public convertUpdateCompositeArticleResult(data: any): UpdateCompositeArticleResult {
    return JsonConvert.deserialize(data, 'UpdateCompositeArticleResult');
  }

  public convertArticleEndPlateInfoVOs(data: any): ArticleEndPlateInfoVO[] {
    return JsonConvert.deserialize(data, '[ArticleEndPlateInfoVO]');
  }

  public convertArticleMetadataVO(data: any): ArticleMetadataVO {
    return JsonConvert.deserialize(data, 'ArticleMetadataVO');
  }

  public convertArticleSearchResultVO(data: any): ArticleSearchResultVO {
    return JsonConvert.deserialize(data, 'ArticleSearchResultVO');
  }

  public convertProjectSaveInfoVO(data: any): ProjectSaveInfoVO {
    return JsonConvert.deserialize(data, 'ProjectSaveInfoVO');
  }

  public convertCustomArticleInfoVO(data: any): CustomArticleInfoVO {
    return JsonConvert.deserialize(data, 'CustomArticleInfoVO');
  }

  public convertGenerationResponseVO(data: any): GenerationResponseVO {
    return JsonConvert.deserialize(data, 'GenerationResponseVO');
  }

  public convertRequestFinalizeProjectResultVO(data: any): RequestFinalizeProjectResultVO {
    return JsonConvert.deserialize(data, 'RequestFinalizeProjectResultVO');
  }

  public convertProjectFinalizationInfoVO(data: any): ProjectFinalizationInfoVO {
    return JsonConvert.deserialize(data, 'ProjectFinalizationInfoVO');
  }

  public convertProjectArticleNumberInfoVO(data: any): ProjectArticleNumberInfoVO {
    return JsonConvert.deserialize(data, 'ProjectArticleNumberInfoVO');
  }

  public convertArticleNumberMappingListVOs(data: any): ArticleNumberMappingListVO[] {
    return JsonConvert.deserialize(data, '[ArticleNumberMappingListVO]');
  }

  public convertTextSizeCheckRequestResponseVOs(data: any): TextSizeCheckRequestResponseVO[] {
    return JsonConvert.deserialize(data, '[TextSizeCheckRequestResponseVO]');
  }

  public convertArticleTechDataValueVOs(data: any): ArticleTechDataValueVO[] {
    return JsonConvert.deserialize(data, "[ArticleTechDataValueVO]")
  }

  public convertFriendListEntryVOs(data: any): FriendListEntryVO[] {
    return JsonConvert.deserialize(data, '[FriendListEntryVO]');
  }

  public convertSharedProjectInfoVO(data: any): SharedProjectInfoVO {
    return JsonConvert.deserialize(data, 'SharedProjectInfoVO');
  }

  public convertSharedProjectGroupInfoVO(data: any): SharedProjectGroupInfoVO {
    return JsonConvert.deserialize(data, 'SharedProjectGroupInfoVO');
  }

  public convertFriendInfoVOs(data: any): FriendInfoVO[] {
    return JsonConvert.deserialize(data, '[FriendInfoVO]');
  }

  public convertFriendListEntryVO(data: any): FriendListEntryVO {
    return JsonConvert.deserialize(data, 'FriendListEntryVO');
  }

  public convertArticleToColorValueInLocalesVOs(data: any): ArticleToColorValueInLocalesVO[] {
    return JsonConvert.deserialize(data, '[ArticleToColorValueInLocalesVO]');
  }

  public convertReportVOs(data: any): ReportVO[] {
    return JsonConvert.deserialize(data, '[ReportVO]');
  }

  public convertCountryInfoVOs(data: any): CountryInfoVO[] {
    return JsonConvert.deserialize(data, '[CountryInfoVO]');
  }

  public convertNotificationVOs(data: any): NotificationVO[] {
    return JsonConvert.deserialize(data, '[NotificationVO]');
  }

  public convertFavoriteArticlesWrapperVOs(data: any): FavoriteArticlesWrapperVO[] {
    return JsonConvert.deserialize(data, '[FavoriteArticlesWrapperVO]');
  }

  public convertArticleNosToHeadMappingVO(data: any): ArticleNosToHeadMappingVO {
    return JsonConvert.deserialize(data, 'ArticleNosToHeadMappingVO');
  }

  public convertCadFormatVOs(data: any): CadFormatVO[] {
    return JsonConvert.deserialize(data, '[CadFormatVO]');
  }

  public convertValidationResultVO(data: any): ValidationResultVO {
    return JsonConvert.deserialize(data, 'ValidationResultVO');
  }

  public convertIOConsumptionResultVO(data: any): IOConsumptionResultVO {
    return JsonConvert.deserialize(data, 'IOConsumptionResultVO');
  }

  public convertUserOptionDefsVO(data: any): UserOptionDefsVO {
    return JsonConvert.deserialize(data, 'UserOptionDefsVO');
  }

  public convertObjects(data: any): Object[] {
    return JsonConvert.deserialize(data, '[Object]');
  }

  public convertDrillingHoleDataVO(data: any): DrillingHoleDataVO {
    return JsonConvert.deserialize(data, 'DrillingHoleDataVO');
  }

  public convertElbridgeHookVO(data: any): ElbridgeHookVO {
    return JsonConvert.deserialize(data, 'ElbridgeHookVO');
  }

  public convertItemListObjectVOs(data: any): ItemListObjectVO[] {
    return JsonConvert.deserialize(data, '[ItemListObjectVO]');
  }

  public convertIEKBuildingBlockVOs(data: any): IEKBuildingBlockVO[] {
    return JsonConvert.deserialize(data, '[IEKBuildingBlockVO]');
  }

  public convertBuildingBlockSaveResponseVO(data: any): BuildingBlockSaveResponseVO {
    return JsonConvert.deserialize(data, 'BuildingBlockSaveResponseVO');
  }

  public convertBuildingBlockVO(data: any): BuildingBlockVO {
    return JsonConvert.deserialize(data, 'BuildingBlockVO');
  }

  public convertBuildingBlockHeadVOs(data: any): BuildingBlockHeadVO[] {
    return JsonConvert.deserialize(data, '[BuildingBlockHeadVO]');
  }

  public convertBuildingBlockHeadVO(data: any): BuildingBlockHeadVO {
    return JsonConvert.deserialize(data, 'BuildingBlockHeadVO');
  }

  public convertTariffNumbers(data: any): CustomsTariffNumberVO[] {
    return JsonConvert.deserialize(data, '[CustomsTariffNumberVO]');
  }

  public convertFinalizationPreselection(data: any): FinalizationPreselectionVO {
    return JsonConvert.deserialize(data, 'FinalizationPreselectionVO');
  }

  public convertProjectLinkAccessVO(data: any): ProjectLinkAccessVO {
    return JsonConvert.deserialize(data, 'ProjectLinkAccessVO');
  }

  public convertArticleColorVariantsInfoVO(data: any): ArticleColorVariantsInfoVO[] {
    return JsonConvert.deserialize(data, '[ArticleColorVariantsInfoVO]');
  }

  public convertConnectionSearchResultVO(data: any): ConnectionSearchResultVO {
    return JsonConvert.deserialize(data, 'ConnectionSearchResultVO')
  }

  public convertAccessorySearchResultVO(data: any): AccessorySearchResultVO {
    return JsonConvert.deserialize(data, 'AccessorySearchResultVO')
  }

  public convertUserRightDefVOs(data: any): UserRightDefVO[] {
    return JsonConvert.deserialize(data, '[UserRightDefVO]');
  }

  public convertUserRightsInfoVO(data: any): UserRightsInfoVO {
    return JsonConvert.deserialize(data, 'UserRightsInfoVO');
  }

  public convertWxArticleVO(data: any): WxArticleVO[] {
    return JsonConvert.deserialize(data, '[WxArticleVO]');
  }
}
